import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e0b4087c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "logo" }
const _hoisted_2 = {
  key: 0,
  class: "sidebar-logo1"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/images/aboitiz-logo.png" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "sidebar-logo"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "images/favicon.ico" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!
  const _component_menu_outlined = _resolveComponent("menu-outlined")!
  const _component_HeaderBar = _resolveComponent("HeaderBar")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, { style: {"min-height":"100vh"} }, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout_sider, {
        collapsed: _ctx.collapsed,
        "onUpdate:collapsed": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.collapsed) = $event)),
        trigger: null,
        collapsible: "",
        breakpoint: "lg",
        class: "sample"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (!_ctx.collapsed)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
              : _createCommentVNode("", true),
            (_ctx.collapsed)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_a_menu, {
            mode: "inline",
            selectedKeys: _ctx.selectedKeys,
            "onUpdate:selectedKeys": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedKeys) = $event)),
            class: "sidebar"
          }, {
            default: _withCtx(() => [
              (!_ctx.collapsed)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8))
                : _createCommentVNode("", true),
              _createVNode(_component_Sidebar)
            ]),
            _: 1
          }, 8, ["selectedKeys"])
        ]),
        _: 1
      }, 8, ["collapsed"]),
      _createVNode(_component_a_layout, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_layout_header, null, {
            default: _withCtx(() => [
              (_ctx.collapsed)
                ? (_openBlock(), _createBlock(_component_menu_outlined, {
                    key: 0,
                    style: {"color":"#fff"},
                    size: "small",
                    class: "trigger",
                    onClick: _cache[2] || (_cache[2] = () => (_ctx.collapsed = !_ctx.collapsed))
                  }))
                : (_openBlock(), _createBlock(_component_menu_outlined, {
                    key: 1,
                    style: {"color":"#fff"},
                    class: "trigger",
                    onClick: _cache[3] || (_cache[3] = () => (_ctx.collapsed = !_ctx.collapsed))
                  })),
              (_ctx.doneNotification)
                ? (_openBlock(), _createBlock(_component_HeaderBar, {
                    key: 2,
                    notifications: _ctx.notifications,
                    notificationCount: _ctx.notificationCount
                  }, null, 8, ["notifications", "notificationCount"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_a_layout_content, { style: { margin: '24px 16px', background: '#fff', minHeight: '280px' } }, {
            default: _withCtx(() => [
              _createVNode(_component_router_view)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}